module.exports = __webpack_public_path__ + "static/media/spin.44376c93.gif";